import type { Endpoint, Route, Request, RequestArgs } from '../types.no-deps'
import type { Answer, DatabaseAnswer, ReportId } from '../../../shared/domain/flows/types.no-deps'

export const route: Route = { method: 'PATCH', pattern: '/api/reports' }

type Params = never
type Body = { answers?: Answer[]; clientId: ReportId; isConfidential?: boolean }
type Query = never
type Output = { answers?: DatabaseAnswer[]; isConfidential?: boolean }

export type EditEndpoint = Endpoint<Params, Body, Query, Output>

export const editReportAnswersRequest = (request: Request, args: RequestArgs<EditEndpoint>) =>
    request<EditEndpoint>(route, args)
